<template>
    <button
        :class="buttonClasses"
        @click="clickHandler"
    >
        <slot />
    </button>
</template>

<script>
export default {
    name: 'VButton',
    props: {
        variant: {
            type: String,
            'default': 'primary',
            validator(value) {
                return ['primary', 'success', 'light', 'secondary'].includes(value);
            },
        },

        size: {
            type: String,
            'default': 'big',
            validator(value) {
                return ['big', 'small'].includes(value);
            },
        },
    },

    emits: ['click'],

    computed: {
        buttonClasses() {
            return ['fp-button', this.variant, this.size];
        },
    },

    methods: {
        clickHandler() {
            if (!this.$attrs.disabled) {
                this.$emit('click');
            }
        },
    },
};
</script>

<style scoped lang="sass">
.fp-button
    font-size: 13px
    height: 48px
    border: 1px solid
    box-shadow: 0 0 0 2px transparent
    transition: box-shadow .2s linear
    border-radius: 4px
    padding: 0 1em
    display: flex
    align-items: center
    justify-content: center
    width: 100%
    outline: none

    &.small
        height: 32px

    &.primary:not(:disabled)
        background-color: #007BFF
        border-color: #007BFF
        color: #ffffff

        &:hover
            background-color: #0062CC
            border-color: #0062CC

        &:active
            border-color: #80BDFF

        &:focus-within
            box-shadow: 0 0 0 2px #007BFF40

    &.success:not(:disabled)
        background-color: #81BB3C
        border-color: #81BB3C
        color: #ffffff

        &:hover
            background-color: #78AD38
            border-color: #78AD38

        &:active
            border-color: #70A234

        &:focus-within
            box-shadow: 0 0 0 2px #81BB3C40

    &.light:not(:disabled)
        background-color: #F8F9FA
        border-color: #F8F9FA
        color: #0953CC

        &:hover
            background-color: #E2E6EA
            border-color: #E2E6EA

        &:active
            background-color: #DAE0E5
            border-color: #E0E0E0
            color: #212529

        &:focus-within
            box-shadow: 0 0 0 2px #D3D9DF80

    &.secondary:not(:disabled)
        background-color: #FFFFFF
        border-color: #3C7BE0
        color: #0953CC

        &:hover
            border-color: #3673D4

        &:active
            border-color: #E0E0E0

        &:focus-within
            border-color: #80BDFF
            box-shadow: 0 0 0 2px #007BFF40

    &.secondary:disabled
        border-color: #EBEBEB
        background-color: #FFFFFF
        color: #B0B0B0

    &:disabled
        background-color: #EBEBEB
        border-color: #EBEBEB
        color: #B0B0B0

@media screen and (max-width: 767px)
    .fp-button
        height: 38px
</style>